// タブ内でGETした後などに、現在開いているタブを開きなおす
document.addEventListener('turbolinks:load', () => {
  const featureTabs = document.getElementById('featureTabs');
  if (!featureTabs) return; // このページ以外では何もしない

  const url = new URL(window.location.href);
  const tab = url.searchParams.get('tab'); // "audits-pane" など

  function activateTab(tabId) {
    // tabId: "audits-pane" のように pane の id
    const paneSelector = `#${tabId}`;

    const link = document.querySelector(`a[data-toggle="tab"][href="${paneSelector}"]`);
    const pane = document.querySelector(paneSelector);

    if (!link || !pane) return;

    document.querySelectorAll('a[data-toggle="tab"]').forEach(a => {
      a.classList.remove('active');
      a.setAttribute('aria-selected', 'false');
    });
    document.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('active', 'show'));

    link.classList.add('active');
    link.setAttribute('aria-selected', 'true');
    pane.classList.add('active', 'show');
  }

  // 初回ロード: ?tab=... があればそのタブを表示
  if (tab) activateTab(tab);

  // タブ切替: URLの ?tab=... を更新 (hash使わないのでスクロールしない)
  document.querySelectorAll('a[data-toggle="tab"]').forEach(a => {
    a.addEventListener('click', () => {
      const href = a.getAttribute('href');
      if (!href || href[0] !== '#') return;
      const tabId = href.slice(1);

      const u = new URL(window.location.href);
      u.searchParams.set('tab', tabId);
      u.hash = '';
      history.replaceState(null, '', u.toString());

      activateTab(tabId);
    });
  });

  const btn = document.getElementById('download-multi-task');
  const form = document.getElementById('submit-download-multi-task');
  const checkboxes = document.querySelectorAll('input[name="volunteer_task_id[]"]');
  if (btn && form) {
    btn.addEventListener('click', () => form.submit());
  }

  function toggleDownloadButton() {
    if (!btn) return;
    const anyChecked = Array.from(checkboxes).some(box => box.checked);
    btn.classList.toggle('d-none', !anyChecked);
  }

  if (checkboxes.length > 0) {
    toggleDownloadButton();
    checkboxes.forEach(box => box.addEventListener('change', toggleDownloadButton));
  }
});
